import type { Config } from "@/types";

// Environment detection
const isDevelopment = import.meta.env.DEV;

export const normalizeApiBaseUrl = (configuredUrl: string): string => {
  const baseUrl = configuredUrl.replace(/\/+$/, "");
  return baseUrl.endsWith("/api") ? baseUrl : `${baseUrl}/api`;
};

// API base URL configuration
const getApiBaseUrl = (): string => {
  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  if (isLocal) {
    return "/api";
  }

  // Respect VITE_API_URL (staging/preview); fall back to production.
  const envUrl = import.meta.env["VITE_API_URL"];
  return normalizeApiBaseUrl(
    envUrl || "https://calendar-tool-production.up.railway.app",
  );
};

const getApiAdminUrl = (): string => {
  return `${getApiBaseUrl()}/admin`;
};

// Clerk configuration
const getClerkPublishableKey = (): string => {
  if (import.meta.env["VITE_DEV_AUTH_BYPASS"] === "true") return "pk_dev_bypass";
  const key = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
  if (!key) {
    throw new Error("Missing VITE_CLERK_PUBLISHABLE_KEY environment variable");
  }
  return key;
};

// Main configuration object
export const config: Config = {
  apiBaseUrl: getApiBaseUrl(),
  apiAdminUrl: getApiAdminUrl(),
  clerkPublishableKey: getClerkPublishableKey(),
  isDevelopment,
};

// Export utilities for common use cases
export const isProduction = !isDevelopment;
export const isLocalDevelopment =
  isDevelopment && window.location.hostname === "localhost";

// Feature flags (for gradual rollout of new features)
export const featureFlags = {
  enableAdvancedAnalytics: true,
  enableTeamPerformanceMetrics: true,
  enableBulkOperations: true,
  enableDarkMode: false, // Coming in Phase 2
} as const;
